module.exports = __webpack_public_path__ + "pigmentace_1_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/pigmentace_1_before_tn.jpg
// module id = 1438
// module chunks = 0